import { COLUMN_CATEGORY, COLUMN_DATE_TIME, COLUMN_DEVICE, COLUMN_DOOR, COLUMN_EVENT, COLUMN_NAME, COLUMN_SITE, COLUMN_TAG_CODE, COLUMN_ZONE } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const TransactionViewerColumn: TableColumn[] = [
    {
        heading: "Event",
        accessor: "name",
        isNumeric: false,
        id: 1,
        active: true,
        searchOnName: "eventId",
        lookupName: 'event',
        translationKey: "event",
        columnId: COLUMN_EVENT,
    },
    {
        heading: "Device",
        accessor: "device",
        isNumeric: false,
        id: 2,
        active: true,
        searchOnName: "deviceId",
        lookupName: 'device',
        translationKey: "device",
        columnId: COLUMN_DEVICE,
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "tagCode",
        columnId: COLUMN_TAG_CODE,
    },
    {
        heading: "Date/Time",
        accessor: "dateTime",
        isNumeric: false,
        id: 4,
        active: true,
        translationKey: "dateTime",
        columnId: COLUMN_DATE_TIME,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 5,
        active: true,
        searchOnName: "siteId",
        lookupName: 'site',
        translationKey: "site",
        columnId: COLUMN_SITE,
    },
    {
        heading: "Credential Holder",
        accessor: "credentialHolder",
        isNumeric: false,
        id: 6,
        active: true,
        translationKey: "credentialHolder",
        columnId: COLUMN_NAME,
    },
    {
        heading: "Door",
        accessor: "door",
        isNumeric: false,
        id: 7,
        active: true,
        searchOnName: "doorId",
        lookupName: 'door',
        translationKey: "door",
        columnId: COLUMN_DOOR,
    },
    {
        heading: "Zone",
        accessor: "zone",
        isNumeric: false,
        id: 8,
        active: false,
        searchOnName: "zoneId",
        lookupName: 'zone',
        translationKey: "zone",
        columnId: COLUMN_ZONE,
    },
    {
        heading: "Category",
        accessor: "category",
        isNumeric: false,
        id: 9,
        active: false,
        searchOnName: "categoryId",
        lookupName: 'category',
        translationKey: "category",
        columnId: COLUMN_CATEGORY,
    }
]

export default TransactionViewerColumn;
